<template>
  <div class="brief-container">
    <div class="brief-title title_font_40">{{ title }}</div>
    <div class="brief-content med_font_18">
      <p v-for="(item, index) in content" :key="index">{{ item }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      typeof: String,
    },
    content: {
      typeof: Array,
    },
  },
};
</script>

<style lang="less" scoped>
.brief-container {
  padding: 70px 0;
  background-color: rgba(251, 251, 251, 1);
  .brief-content {
    max-width: 1032px;
    padding: 0 20px;
    margin: 0 auto;
    margin-top: 30px;
    p {
      margin-top: 16px;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/components/briefBox.vue